<template>
	<div>
		<div v-if="fileUrl">
			<div v-if="!isPdfFile" class="image-wrapper pos-rel">
				<img :src="fileUrl" class="d-block uploaded-image" />
			</div>
			<div v-else style="height: 120px" class="pa-2">
				<div class="mb-4">
					<a class="break-all" :href="fileUrl">
						{{ fileUrl }}
					</a>
				</div>
				<div v-if="!disabled" class="allCenteredChild">
					<div class="uploadSuccess">
						<v-icon dark>done</v-icon>
					</div>
					<div class="px-2 green--text">
						File Upload Success!
					</div>
				</div>
			</div>
			<div v-if="!disabled" class="text-center">
				<v-btn color="error" @click="resetUrl" outline>
					<v-icon>edit</v-icon>
					<span>Upload New File</span>
				</v-btn>
			</div>
		</div>
		<div
			v-show="!fileUrl"
			class="upload-region px-3 pt-3 pb-4 pos-rel"
			@click="openFileExplorer"
		>
			<label
				for="file"
				class="full-width d-block text-xs-center grey--text text--darken-3"
			>
				<div class="d-flex flex-column">
					<div>
						<v-icon class="upload-icon">cloud_upload</v-icon>
					</div>
					<div>
						<a>
							<strong>{{ text }}</strong>
						</a>
					</div>
				</div>
			</label>
			<input
				ref="fileExplorer"
				@change="uploadImage"
				type="file"
				name="photo"
				:accept="accept"
				hidden
			/>
			<div
				v-if="isLoading"
				class="loading-abs-center half-opacity full-height full-width white"
			></div>
			<div v-if="isLoading" class="loading-abs-center">
				<v-progress-circular
					indeterminate
					color="primary"
				></v-progress-circular>
			</div>
		</div>
	</div>
</template>

<script>
import { UPLOAD_MEDIA_TO_SERVER } from "../../store/action-types";
// import FileUpload from "vue-upload-component";

export default {
	name: "UploadMedia",
	props: {
		refType: {
			type: String
		},
		acceptsReg: {
			validator: function(value) {
				// The value must match one of these strings
				return value instanceof RegExp;
			},
			default: () =>
				/\.(gif|jpg|jpeg|png|webp|mp4|avi|3gp|mpeg|3gpp|mkv|wmv|mov)$/i
		},
		postType: {
			type: String,
			default: "media"
		},
		text: {
			type: String
		},
		accept: {
			type: String
		},
		fileUrl: {
			type: String
		},
		disabled: {
			type: Boolean
		}
	},
	computed: {
		isPdfFile() {
			return this.fileUrl.includes(".pdf");
		}
	},
	components: {
		// FileUpload
	},
	data() {
		return {
			files: [],
			isLoading: false
		};
	},
	methods: {
		openFileExplorer() {
			this.$refs.fileExplorer.click();
		},
		resetUrl() {
			this.openFileExplorer();
			this.$emit("SAVE_FILE_URL", { fileUrl: "" });
		},
		uploadImage(e) {
			let files = e.target.files;
			if (!files[0]) {
				return;
			}
			if (!this.isLoading) {
				this.isLoading = true;
				this.$store
					.dispatch(UPLOAD_MEDIA_TO_SERVER.dispatch, {
						key: this.uploadKey,
						file: files[0],
						type: "imageUpload"
					})
					.catch(() => {})
					.then(data => {
						console.log("data: ", data);
						this.$emit("SAVE_FILE_URL", data);
						// debugger;
						this.isLoading = false;
					});
			}

			e.target.value = "";
		}
	}
};
</script>

<style lang="scss">
.upload-region {
	border: 2px dashed #ccc;
	.upload-icon {
		font-size: 75px;
	}
	a {
		cursor: pointer;
		text-decoration: underline;
	}
}
.upload-region .drop-active {
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
	position: fixed;
	z-index: 9999;
	opacity: 0.6;
	text-align: center;
	background: #000;
}
.upload-region .drop-active h3 {
	margin: -0.5em 0 0;
	position: absolute;
	top: 50%;
	left: 0;
	right: 0;
	-webkit-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	transform: translateY(-50%);
	font-size: 40px;
	color: #fff;
	padding: 0;
}
.uploadSuccess {
	background: green;
	height: 25px;
	width: 25px;
	border-radius: 50%;
}
.loading-abs-center {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}
.half-opacity {
	opacity: 0.5;
}
.image-wrapper {
	position: relative;
	min-height: 240px;
}
.uploaded-image {
	height: 100%;
	width: 100%;
	object-fit: contain;
	margin: auto;
	position: absolute;
}
</style>
